import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, UserPlus, X } from "lucide-react";
import { adminApi, errorMessage } from "@/api";

const inputCls = "w-full h-10 px-3 bg-white border border-slate-300 rounded-md text-sm focus:border-emerald-600 outline-none";
const labelCls = "text-sm font-semibold text-slate-700 mb-1.5 block";

export default function Usuarios() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ email: "", nombre: "", role: "operador", password: "" });

  const load = () => adminApi.get("/admin/users").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ email: "", nombre: "", role: "operador", password: "" }); setModal({ mode: "new" }); };
  const openEdit = (u) => { setForm({ email: u.email, nombre: u.nombre, role: u.role, password: "" }); setModal({ mode: "edit", id: u.id }); };

  const save = async () => {
    try {
      if (modal.mode === "new") await adminApi.post("/admin/users", form);
      else await adminApi.put(`/admin/users/${modal.id}`, form);
      toast.success("Usuario guardado");
      setModal(null);
      load();
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };

  const remove = async (u) => {
    if (!window.confirm(`Eliminar al usuario ${u.email}?`)) return;
    try {
      await adminApi.delete(`/admin/users/${u.id}`);
      toast.success("Usuario eliminado");
      load();
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };

  return (
    <div data-testid="admin-usuarios">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading text-2xl font-bold text-slate-900">Usuarios del panel</h1>
        <button data-testid="nuevo-usuario-button" onClick={openNew} className="flex items-center gap-2 h-10 px-4 rounded-[10px] bg-[#1C1C1E] hover:bg-zinc-800 text-white text-sm font-semibold">
          <UserPlus className="w-4 h-4" /> Nuevo usuario
        </button>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="users-table">
          <thead><tr className="border-b border-slate-200 text-left text-xs text-slate-500 uppercase"><th className="p-3">Email</th><th className="p-3">Nombre</th><th className="p-3">Rol</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} className="border-b border-slate-100" data-testid={`user-row-${u.email}`}>
                <td className="p-3 font-medium text-slate-800">{u.email}</td>
                <td className="p-3 text-slate-600">{u.nombre || "-"}</td>
                <td className="p-3"><span className={`text-xs font-semibold px-2 py-1 rounded-full ${u.role === "admin" ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"}`}>{u.role}</span></td>
                <td className="p-3 text-right whitespace-nowrap">
                  <button data-testid={`edit-${u.email}`} onClick={() => openEdit(u)} className="text-emerald-600 text-xs font-medium hover:underline mr-3">Editar</button>
                  <button data-testid={`delete-${u.email}`} onClick={() => remove(u)} className="text-red-600 text-xs font-medium hover:underline"><Trash2 className="w-3.5 h-3.5 inline" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-400 mt-3">Rol <b>admin</b>: acceso total (credenciales, usuarios, pixeles). Rol <b>operador</b>: solo CRM y operaciones.</p>

      {modal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="user-modal">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-heading font-bold text-slate-900">{modal.mode === "new" ? "Nuevo usuario" : "Editar usuario"}</h2>
              <button onClick={() => setModal(null)}><X className="w-5 h-5 text-slate-400" /></button>
            </div>
            <div className="space-y-3">
              <div><label className={labelCls}>Email</label><input data-testid="user-email" className={inputCls} type="email" value={form.email} disabled={modal.mode === "edit"} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><label className={labelCls}>Nombre</label><input data-testid="user-nombre" className={inputCls} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} /></div>
              <div><label className={labelCls}>Rol</label>
                <select data-testid="user-role" className={inputCls} value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
                  <option value="operador">Operador / Comercial</option>
                  <option value="admin">Administrador</option>
                </select>
              </div>
              <div><label className={labelCls}>{modal.mode === "new" ? "Contrasena" : "Nueva contrasena (dejar vacio para no cambiar)"}</label>
                <input data-testid="user-password" type="password" className={inputCls} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
            </div>
            <button data-testid="user-save-button" onClick={save} className="w-full h-10 mt-5 rounded-[10px] bg-[#1C1C1E] hover:bg-zinc-800 text-white text-sm font-semibold">Guardar</button>
          </div>
        </div>
      )}
    </div>
  );
}
